module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nba/assists/basketball_assists-2575617fdde479679442e855eb027e8d.svg";